import useFormatDate from '@/src/hooks/date/useFormatDate'
import { TransformedSegmentData } from '@/src/utils/itinerary/flightTransformers'
import { useTranslations } from 'next-intl'
import SegmentBlock from './segmentBlock'

interface SegmentBlockWrapperProps {
    segmentData: TransformedSegmentData
    isConfirmationPage?: boolean
}

const SegmentBlockWrapper = ({ segmentData, isConfirmationPage = false }: SegmentBlockWrapperProps) => {
    const { formatDate } = useFormatDate()

    const {
        departureTime,
        arrivalTime,
        departureAirport,
        departureTerminal,
        arrivalAirport,
        arrivalTerminal,
        duration,
        cabinType,
        operatingAirlineName,
        ...rest
    } = segmentData
    const t = useTranslations('common')

    const operatedBy = operatingAirlineName ? t('operatingAirlineName', { operatingAirlineName }) : ''

    const formattedDepartureAirport = t(
        `formattedAirportName${departureTerminal ? 'WithTerminal' : 'WithoutTerminal'}`,
        {
            airport: departureAirport,
            terminal: departureTerminal
        }
    )
    const formattedArrivalAirport = t(`formattedAirportName${arrivalTerminal ? 'WithTerminal' : 'WithoutTerminal'}`, {
        airport: arrivalAirport,
        terminal: arrivalTerminal
    })
    const formattedDuration = t('duration', {
        hours: duration.hours,
        minutes: duration.mins
    })
    const cabinTypeValue = cabinType.charAt(0).toUpperCase() + cabinType.slice(1).toLowerCase()
    const formattedCabinType = t(cabinTypeValue).toUpperCase()
    return (
        <SegmentBlock
            departureTime={formatDate(departureTime, 'HH:mm')}
            arrivalTime={formatDate(arrivalTime, 'HH:mm')}
            departureAirport={formattedDepartureAirport}
            arrivalAirport={formattedArrivalAirport}
            duration={formattedDuration}
            cabinType={formattedCabinType}
            isConfirmationPage={isConfirmationPage}
            operatedBy={operatedBy}
            {...rest}
        />
    )
}

export default SegmentBlockWrapper
